import React from 'react';
import { hot } from 'react-hot-loader';

export default hot(module)(function error(props) {
	return (
		<span style={{ marginTop: '5px' }} className="error">
			{props.text}
		</span>
	);
});
